import React from 'react';

import { Container } from './styles';

import InputTextAreaSp from '../../../../components/InputTextareaSp';

function InputTextArea(props) {
  const { required, ...rest } = props;

  return (
    <Container required={required}>
      <InputTextAreaSp className={required ? 'required' : ''} {...rest} />
    </Container>
  );
}

export default InputTextArea;
